import { render, staticRenderFns } from "./AdminStudyMapForm.vue?vue&type=template&id=022b9ef5&"
import script from "./AdminStudyMapForm.vue?vue&type=script&lang=js&"
export * from "./AdminStudyMapForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports